import { get } from 'lodash';

/**
 * A utility method that provides the current premium status.
 *
 * @return {boolean} - True if premium, otherwise false.
 */
function isPremium() {
	return get(window, 'automaticBlockInserter.isPremium', 'false') === 'true';
}

export default isPremium;
